import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

// export const fetchDoctorAvailability = createAsyncThunk(
//   "report/fetchDoctorAvailability",
//   async (credentials, { rejectWithValue }) => {
//     try {
//       const response = await AxiosInstance.get(API_ENDPOINTS.DOCTOR_SLOTS, {
//         params: credentials,
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data?.message || "Something went wrong"
//       );
//     }
//   }
// );
export const createVitals = createAsyncThunk(
  "report/createVitals",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.CREATE_VITAL,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const initialState = {
  vitals: {
    loading: false,
    error: null,
    data: null,
  },
};

// ------------------ SLICE ------------------
const VitalSlice = createSlice({
  name: "Vital",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createVitals.pending, (state) => {
        state.vitals.loading = true;
        state.vitals.error = null;
      })
      .addCase(createVitals.fulfilled, (state, action) => {
        state.vitals.loading = false;
        state.vitals.data = action.payload;
      })
      .addCase(createVitals.rejected, (state, action) => {
        state.vitals.loading = false;
        state.vitals.error = action.payload;
      });
  },
});

export default VitalSlice.reducer;
